<template>
  <div class="h-12 my-10 u-center">
    <OButton
      v-if="!loading"
      class="w-full h-[48px] sm:h-[55px] mx-4 sm:mx-0 border border-o-blue rounded-md text-o-blue hover:text-white hover:bg-o-blue"
      pure
      size="md"
      @click="$emit('click')"
    >
      {{ $t('main.load-more') }}
    </OButton>
    <OLoading v-else />
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { OButton, OLoading } from '~/modules/common/components/ui';

export default defineComponent({
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
  },
  components: { OLoading, OButton },
});
</script>
